const userTypes = [
  { value: 'USER', label: 'ผู้ใช้งาน' },
  { value: 'ADMIN', label: 'ผู้ดูแลระบบ' }
];

const permissionAdmins = [
  { value: 'NORMAL_ADMIN', label: 'เจ้าหน้าที่ดูแลระบบ' }
  // { value: 'SUPER_ADMIN', label: 'แอดมินระบบ' }
];

const permissionUsers = [
  // { value: 'BUDGET_STAFF', label: 'เจ้าหน้าที่การคลัง-งบวิจัย' },
  // { value: 'BUDGET_MANAGER', label: 'หัวหน้าเจ้าหน้าที่การคลัง-งบวิจัย' },
  // { value: 'ADMINISTRATIVE_STAFF', label: 'เจ้าหน้าที่การคลัง-งบบริหาร' },
  // { value: 'ADMINISTRATIVE_MANAGER', label: 'หัวหน้าเจ้าหน้าที่การคลัง-งบบริหาร' },
  // { value: 'PAYMENT', label: 'เจ้าหน้าที่การเงิน' },
  { value: 'CUSTOMER', label: 'ลูกค้า' }
];

const getUserTypeDisplay = (value?: string) => {
  return userTypes.find((f) => f.value === value)?.label ?? value;
};

const getPermissionAdminsDisplay = (value?: string) => {
  return permissionAdmins.find((f) => f.value === value)?.label ?? value;
};

const getPermissionUsersDisplay = (value?: string) => {
  return permissionUsers.find((f) => f.value === value)?.label ?? value;
};

const getPermissionDisplay = (value?: string) => {
  return [...permissionUsers, ...permissionAdmins].find((f) => f.value === value)?.label ?? value;
};

const budgetTypes = [
  { value: 'research', label: 'งบโครงการวิจัย' },
  { value: 'administrative', label: 'งบโครงการบริหาร' }
];

export {
  userTypes,
  permissionAdmins,
  permissionUsers,
  budgetTypes,
  getUserTypeDisplay,
  getPermissionAdminsDisplay,
  getPermissionUsersDisplay,
  getPermissionDisplay
};
